<script setup lang="ts" />

<template>
  <q-tab v-bind="$attrs" :ripple="false" v-ripple>
    <!-- pass through slots -->
    <template v-if="$slots.default" #default>
      <slot name="default" />
    </template>
  </q-tab>
</template>
